import { Button, ButtonSize, ButtonVariant, ScrollLock } from '@farmasiet/frontendcore-reactcomponents';
import classNames from 'classnames';
import * as React from 'react';
import { v4 as uuid } from 'uuid';

import { PictureProfile } from '../../../../ResizedImage/PictureProfile.csharp';
import { getTranslation, keys } from '../../../../Resources/Translations';
import { DuraphatSettings } from '../../../Blocks/FormsConfiguration/Duraphat/DuraphatSettings.csharp';
import { PriceDisplay } from '../../PriceDisplay';
import { ResponsivePicture } from '../../ResponsivePicture/ResponsivePicture';
import { ResponsivePictureViewModel } from '../../ResponsivePicture/ResponsivePictureViewModel.csharp';

interface DuraphatFormProps {
    pictureProfile: PictureProfile;
    isVisible: boolean;
    addToCart: () => void;
    closeForm: () => void;
    image: ResponsivePictureViewModel;
    brandName: string;
    productName: string;
    productPrice: number;
    formConfiguration: DuraphatSettings;
}

interface DuraphatFormState {
    isCheckboxChecked: boolean;
}

// eslint-disable-next-line
declare let zE: any;

export class DuraphatForm extends React.Component<DuraphatFormProps, DuraphatFormState> {
    private readonly checkboxId: string;

    constructor(props: DuraphatFormProps) {
        super(props);
        this.checkboxId = uuid();
    }

    state = {
        isCheckboxChecked: false
    };

    render() {
        const { pictureProfile, isVisible, closeForm, image, brandName, productName, productPrice, formConfiguration } = this.props;

        return (
            <div className={classNames('DuraphatForm', isVisible && 'DuraphatForm--Visible')} onClick={closeForm}>
                <ScrollLock isLocked={isVisible} removeScroll={isVisible} bodyClassName="ScrollLock--HelpOnTop" />

                <div className="DuraphatForm__Content" onClick={(e) => e.stopPropagation()}>
                    <button className="DuraphatForm__CloseButton" onClick={this.props.closeForm}>
                        <span className="visuallyHidden">Close form</span>
                    </button>

                    <div className="DuraphatForm__ContentInner">
                        <h4 className="DuraphatForm__ContentHeader">Reseptfritt med veiledning</h4>
                        <div className="DuraphatForm__Product">
                            <div className="DuraphatForm__ProductImage">
                                <ResponsivePicture profile={pictureProfile} model={image} isLazyLoaded />
                            </div>
                            <div className="DuraphatForm__ProductDetails">
                                <span className="DuraphatForm__ProductBrand">{brandName}</span>
                                <span className="DuraphatForm__ProductName">{productName}</span>
                            </div>
                            <span className="DuraphatForm__ProductPrice">
                                <PriceDisplay price={productPrice} roundUp />
                            </span>
                        </div>

                        <div className="DuraphatForm__WarningContent">
                            <div className="CustomCheckbox">
                                <input
                                    type="checkbox"
                                    id={this.checkboxId}
                                    checked={this.state.isCheckboxChecked}
                                    onChange={() => this.setState({ isCheckboxChecked: !this.state.isCheckboxChecked })}
                                />
                                <label htmlFor={this.checkboxId}>{getTranslation(keys['duraphatForm.confirm'])}</label>
                            </div>

                            <p className="DuraphatForm__ConsentText">{getTranslation(keys['duraphatForm.ageConsent'])}:</p>

                            <ul className="DuraphatForm__List">
                                <li className="DuraphatForm__ListItem">{getTranslation(keys['duraphatForm.cavities'])}</li>
                                <li className="DuraphatForm__ListItem">{getTranslation(keys['duraphatForm.visibleRoots'])}</li>
                                <li className="DuraphatForm__ListItem">{getTranslation(keys['duraphatForm.hygieneDifficulties'])}</li>
                                <li className="DuraphatForm__ListItem">{getTranslation(keys['duraphatForm.dryMouth'])}</li>
                            </ul>

                            <div className="DuraphatForm__WarningFooter">
                                <a href={formConfiguration.usageInformationLink} target="_blank" rel="noreferrer">
                                    {getTranslation(keys['duraphatForm.importantInformation'])}
                                </a>
                                &nbsp;<span>{getTranslation(keys['duraphatForm.orSee'])}</span>&nbsp;
                                <a href={formConfiguration.questionsAndAnswersLink} target="_blank" rel="noreferrer">
                                    {getTranslation(keys['duraphatForm.QA'])}
                                </a>
                            </div>
                        </div>

                        <div className="DuraphatForm__ButtonWrapper">
                            <Button
                                size={ButtonSize.Medium}
                                variant={ButtonVariant.Tertiary}
                                className="DuraphatForm__ContactButton"
                                onClick={this.openZenDesk}
                            >
                                {getTranslation(keys['duraphatForm.contact'])}
                            </Button>
                            <Button
                                size={ButtonSize.Medium}
                                className="DuraphatForm__BuyButton"
                                onClick={this.addToCart}
                                disabled={!this.state.isCheckboxChecked}
                            >
                                {getTranslation(keys['duraphatForm.buy'])}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private addToCart = () => {
        if (this.state.isCheckboxChecked) {
            this.closeZenDesk();
            this.props.addToCart();
            this.props.closeForm();
        }
    };

    private openZenDesk = () => {
        typeof zE !== 'undefined' && zE('webWidget', 'open');
    };

    private closeZenDesk = () => {
        typeof zE !== 'undefined' && zE('webWidget', 'close');
    };
}
